import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { DriverActivationPrintRequest } from "./DriverActivationPrintRequest";
import { QREmailRequest } from "./QREmailRequest";
import { PreviewQRRequest } from "./PreviewQRRequest";

@Injectable()
export class DataService_DriverVerifyActivation {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	DriverActivationSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DriverActivationSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DriverActivationInsert(AvailableCount, TotalCount, IssueDate, ExpireDate) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/DriverActivationInsert?AvailableCount=" +
			AvailableCount +
			"&TotalCount=" +
			TotalCount +
			"&IssueDate=" +
			IssueDate +
			"&ExpireDate=" +
			ExpireDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DriverActivationUpdate(DriverVerifyActivationID, AvailableCount, TotalCount, ExpireDate) {
		var postResult$ = new Subject();
		var url =
			"DistrictAdministration/DriverActivationUpdate?DriverVerifyActivationID=" +
			DriverVerifyActivationID +
			"&AvailableCount=" +
			AvailableCount +
			"&TotalCount=" +
			TotalCount +
			"&ExpireDate=" +
			ExpireDate;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DriverActivationPreviewDebugQRCode(parms: PreviewQRRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DriverActivationPreviewDebugQRCode";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DriverActivationPrint(parms: DriverActivationPrintRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DriverActivationPrint";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DriverActivationEmail(parms: QREmailRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/DriverActivationEmail";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
